import * as React from 'react';
import isSameMonth from 'date-fns/isSameMonth';
import { formatDate } from '../../utils/dateUtils';
import isSameDay from 'date-fns/isSameDay';
import { ICourseCarouselItem } from '.';
import Tag from '../Tag';
import { getActivityStatusTag } from '../../utils/activityUtils';

type CarouselLocationProps = {
  status: ICourseCarouselItem['status'];
  location: string;
  dateRange: null | [string, string];
};

const formatDateRange = (startDate: Date, endDate: Date): string => {
  if (isSameDay(startDate, endDate)) {
    return formatDate(startDate, 'd. MMMM yyyy');
  }

  if (isSameMonth(startDate, endDate)) {
    const start = formatDate(startDate, 'd');
    const end = formatDate(endDate, 'd. MMMM yyyy');
    return `${start} – ${end}`;
  }

  return `${formatDate(startDate, 'd. MMMM')} – ${formatDate(endDate, 'd. MMMM yyyy')}`;
};

const CarouselLocation = (props: CarouselLocationProps) => {
  const ref = React.useRef<HTMLDivElement | null>(null);
  const cloneRef = React.useRef<HTMLDivElement | null>(null);
  const startDate = React.useMemo(
    () => props.dateRange ? new Date(props.dateRange[0]) : null,
    [props.dateRange]
  );
  const endDate = React.useMemo(
    () => props.dateRange ? new Date(props.dateRange[1]) : null,
    [props.dateRange]
  );

  React.useLayoutEffect(() => {
    cloneRef.current = ref.current?.cloneNode(true) as HTMLDivElement;

    if (cloneRef.current) {
      ref.current?.classList.add('in');
    }

    return () => {
      if (ref.current && cloneRef.current) {
        const clone = cloneRef.current;

        ref.current.classList.remove('in');
        clone.classList.add('out');
        ref.current.parentElement?.insertBefore(clone, ref.current);

        clone.addEventListener('animationend', () => {
          clone.remove();
        });


        cloneRef.current = null;
      }
    };
  }, []);

  return (
    <div className="carousel-location" ref={ref}>
      <Tag
        className="course-carouses-status"
        {...getActivityStatusTag(props.status)}
      />
      <dl>
        <dt>Sted:</dt>
        <dd>
          {props.location}
          {!props.location && (
            <span className="i">Kommer snart</span>
          )}
        </dd>
        {startDate && endDate && (
          <>
            <dt>Dato:</dt>
            <dd>{formatDateRange(startDate, endDate)}</dd>
          </>
        )}
      </dl>
    </div>
  );
}

export default CarouselLocation;



// WEBPACK FOOTER //
// ./src/components/CourseCarousel/Location.tsx